import { render, staticRenderFns } from "./PT125ProductDetailsParts.vue?vue&type=template&id=71bad8a6&scoped=true&"
import script from "./PT125ProductDetailsParts.vue?vue&type=script&lang=js&"
export * from "./PT125ProductDetailsParts.vue?vue&type=script&lang=js&"
import style0 from "./PT125ProductDetailsParts.vue?vue&type=style&index=0&id=71bad8a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bad8a6",
  null
  
)

export default component.exports